import { FormResource } from "../locales";

export const form: FormResource = {
    rangeOverflow: "Verdien bør ikke være høyere enn {{max}}.",
    rangeUnderflow: "Verdien bør ikke være lavere enn {{min}}.",
    required: "Feltet er obligatorisk.",
    invalidEmail: "Ugyldig e-postadresse.",
};
